import styled from 'styled-components';
import { Row } from 'react-bootstrap';

export const DetailsWrapper = styled.div`
  max-height: ${({ show }) => (show ? '300px' : '0')};
  opacity: ${({ show }) => (show ? 1 : 0)};
  overflow-y: ${({ show }) => (show ? 'auto' : 'hidden')};
  overflow-x: hidden;
  transition: max-height 0.5s ease, opacity 0.3s ease;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-right: 0.5rem;
  width: 100%;

  /* scrollbar custom */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 6px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #aaa;
  }
`;
